import { parse } from '@exo/frontend-common-utils';

const SSO_RETURN_URL_ENTRY = 'sso-return-url';
const SSO_RETURN_TS_ENTRY = 'sso-return-timestamp';

export const saveSSOReturnUrl = () => {
  try {
    if (typeof window === 'undefined') return;
    let currentUrl = window.location.pathname + window.location.search;
    if (currentUrl.includes('/auth/') || currentUrl.includes('/error')) {
      currentUrl = '/content/homepage';
    }
    window.sessionStorage.setItem(SSO_RETURN_URL_ENTRY, currentUrl);
    window.sessionStorage.setItem(SSO_RETURN_TS_ENTRY, Date.now().toString());
  } catch (e) {
    // ignore storage failure
  }
};

export const clearSSOReturnUrl = () => {
  try {
    if (typeof window === 'undefined') return;
    window.sessionStorage.removeItem(SSO_RETURN_URL_ENTRY);
    window.sessionStorage.removeItem(SSO_RETURN_TS_ENTRY);
  } catch (e) {
    // ignore storage failure
  }
};

export const getSSOReturnUrl = () => {
  try {
    if (typeof window === 'undefined') return null;
    return window.sessionStorage.getItem(SSO_RETURN_URL_ENTRY) || null;
  } catch (e) {
    return null;
  }
};

export const hasErrorCode = (e, code) =>
  !!e.find(err =>
    [err?.extensions?.exception?.code, err?.extensions?.code].includes(code)
  );

export const hasBadErrorCode = (e, code) =>
  !!e.find(err =>
    [err?.extensions?.exception?.message, err?.extensions?.exception?.message].indexOf(code)
  );

export const getHasBadRequestError = e => hasBadErrorCode(e, '400');
export const getCommerceErrorType = e => e?.[0].extensions?.response?.body?.errors?.[0]?.type;

export const getHasAuthError = e => hasErrorCode(e, 'UNAUTHENTICATED');
export const getHasShipToCustomerError = e =>
  hasErrorCode(e, 'ACCESS_DENIED_ERROR');
export const getHasNegativePriceError = e =>
  hasErrorCode(e, 'NEGATIVE_PRICE_ERROR');

export const getHasSessionError = e =>
  getCommerceErrorType(e) === 'CastrolShopSessionError'

export const getHasCartError = e => {
  const errorType = getCommerceErrorType(e);
  return errorType === 'CartError';
};

export const getCartErrorDetails = e => {
  const errors = e || [];
  const cartError = errors.find(err => getCommerceErrorType([err]) === 'CartError');
  return cartError?.extensions?.response?.body?.errors?.[0] || {};
};

export const getUserRolesFromLocalStorage = (jwtSecret) => {
  if (!jwtSecret) return ['b2bbasic'];

  const sessionContext = window.localStorage.getItem('sessionContext') || '';
  const encryptedRoles = parse(sessionContext)?.roles || '';

  return encryptedRoles || ['b2bbasic'];
}

const MSAL_AUTH_RESULT_ENTRY = 'auth.msalLastAuthResult';

/**
 * Wipe every stale MSAL storage key from both localStorage and sessionStorage.
 */
export const clearMsalStorage = () => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(MSAL_AUTH_RESULT_ENTRY);
    window.sessionStorage.removeItem(MSAL_AUTH_RESULT_ENTRY);
    window.localStorage.removeItem('msal.account');
    window.localStorage.removeItem('auth.redirectState');
    window.sessionStorage.removeItem('msal.interaction.lock');
    window.sessionStorage.removeItem('msal.redirectRecoveryAttempted');
    window.sessionStorage.removeItem('auth.internal.flow.lock');
  } catch (e) { /* ignore — storage errors must not block the caller */ }
};

export const clearPIIData = (error) => {
  let err;
  if (typeof error === 'object') {
    err = JSON.stringify(error);
    err = err.replaceAll(/ userId: \[[A-Za-z0-9]+\]/g, ' userId: [XXX]');
    return JSON.parse(err);
  }
  return error;
}

export const isPublicRoute = () =>
  typeof window !== 'undefined'
  && (window.location?.pathname || '').includes('/itr/');

export const isUnrecoverableMsalSessionError = (e) => {
  const errorCode = String(e?.errorCode || e?.error || '');
  const errorDescription = String(
    e?.errorDescription ||
    e?.error_description ||
    e?.message ||
    ''
  );

  return (
    errorCode.includes('invalid_grant') ||
    errorDescription.includes('AADSTS700084')
  );
};
